module.exports = __webpack_public_path__ + "assets/detectify.da418d09.svg";